import React from "react";
import "../css/delivery.scss";
import { Link } from "react-router-dom";

function Delivery() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="delivery">
      <div className="container">
        <div className="delivery-content">
          <h1>Shipping information</h1>
          <p className="intro">Explore our shipping information and pricing.</p>

          <section className="delivery-section">
            <h2>Bank holidays</h2>
            <p>
              Please note, Royal Mail does not collect orders from us during
              bank holidays and weekends. If you'd like your order in time
              please choose our DPD delivery option.
            </p>
          </section>

          <section className="delivery-section">
            <h2>Shipping prices</h2>

            <h3>United Kingdom</h3>

            <div className="shipping-option">
              <h4>Royal Mail Tracked 48 (2 to 3 business day delivery) *</h4>
              <p className="price">$3.95 (Free over $40)</p>
            </div>

            <div className="shipping-option">
              <h4>
                DPD 24 Hour Next business day delivery - Order before 12pm
                (Monday - Friday)*
              </h4>
              <p className="price">$7.95 (Free over $100)</p>
            </div>

            <div className="shipping-option">
              <h4>Click and collect (Brighton)*</h4>
              <p className="price">Free</p>
            </div>

            <hr className="divider" />

            <div className="shipping-detail">
              <h4>*Royal Mail Tracked 48 (2 to 3 day delivery)</h4>
              <p>
                Standard shipping to UK mainland, Northern Ireland, Channel
                Islands and Scottish Highlands is <strong>FREE</strong> when you
                spend $40.
              </p>
              <p>
                We charge $3.95 for anything below the $40 threshold. We
                subsidise our shipping costs to keep them as low as possible and
                we don't charge you for packaging. We ship our parcels with
                Royal Mail using a 48 hour Tracked service. Items typically
                arrive within two working days after dispatch. Royal Mail will
                send you details of your delivery and your parcel's progress can
                be tracked through the link. They're reliable and fast but we do
                have an express option for urgent stationery needs.
              </p>
            </div>

            <div className="shipping-detail">
              <h4>* DPD 24 Hour (Next business day)</h4>
              <p>
                Our DPD service is <strong>FREE</strong> when you spend over
                $100.
              </p>
              <p>
                Express shipping to UK mainland is charged at $7.95 We ship our
                express parcels with DPD using a next business day service. DPD
                will send you details of your delivery and your parcel's
                progress can be tracked through the link.
              </p>
              <p>
                For express shipping orders,{" "}
                <strong>
                  if you place your order before 12pm Monday - Friday it will
                  leave us that day and arrive with you the next working day. We
                  do not post orders out from Friday 12pm until Monday 9am.
                </strong>{" "}
                Give us a call on 01273 696769 if you miss our 12pm cut off and
                need your order the next day - we'll always do our best to
                prioritise it.
              </p>
              <p>
                Our courier, DPD, is currently delivering parcels to UK mainland
                within their usual timeframe.
              </p>
            </div>

            <h3>*Click and Collect</h3>
            <p>
              We are open for same-day Click and Collect in our Brighton shop.
              Our address is:
            </p>
            <p className="address">
              pittleforestandco, 21 Sydney Street, Brighton, BN1 4EN
            </p>
            <p>
              When your order is ready to collect, we'll email you. It'll
              usually be ready on the same day. We're open for collections from
              10am-6pm every day. Call us on 01273 696769 with any questions.
            </p>

            <h3>Europe</h3>
            <p>
              We are currently unable to ship to Europe. Please visit our Wolf &
              Badger shop{" "}
              <Link onClick={toTop} to="/" className="link">
                here
              </Link>{" "}
              for select styles available to ship to Europe destinations through
              their site. We hope to find a way to set this up on our own
              website soon.
            </p>

            <h3>International shipping</h3>
            <p>
              For exact overseas shipping prices and timeframes, please see the
              total cost at checkout. If you have any problems or can't see your
              country as an option, please contact our team at{" "}
              <strong>round@pittleforestandco.shop.</strong>
            </p>
            <p>
              Please note you are responsible for paying international shipping
              and custom charges. You can see more information on this below.
            </p>
          </section>

          <section className="delivery-section">
            <h2>Shipping Prices</h2>
            <p>
              Shipping is <strong>FREE</strong> for all orders over $40 for UK
              customers
            </p>

            <div className="shipping-table">
              <div className="table-row">
                <span className="table-cell">United Kingdom</span>
                <span className="table-cell">
                  Royal Mail Tracked 48 (2 to 3 day delivery) *
                </span>
                <span className="table-cell">$3.95 (Free over $40)</span>
              </div>
              <div className="table-row">
                <span className="table-cell">United Kingdom</span>
                <span className="table-cell">
                  DPD 24 Hour (Next business day)*
                </span>
                <span className="table-cell">$7.95 (Free over $100)</span>
              </div>
              <div className="table-row">
                <span className="table-cell">Brighton, United Kingdom</span>
                <span className="table-cell">Click and Collect*</span>
                <span className="table-cell">Free</span>
              </div>
              <div className="table-row">
                <span className="table-cell">EU</span>
                <span className="table-cell">
                  We recommend shopping on our Trouva
                </span>
                <span className="table-cell">-</span>
              </div>
              <div className="table-row">
                <span className="table-cell">USA and Canada</span>
                <span className="table-cell">
                  For exact overseas shipping prices and timeframes, please see
                  the total cost at checkout or contact us our team for more
                  information
                </span>
                <span className="table-cell">USA Temporarily Suspended</span>
              </div>
              <div className="table-row">
                <span className="table-cell">
                  Australia and other international locations
                </span>
                <span className="table-cell">
                  We ship to most locations. For exact overseas shipping prices
                  and timeframes, please see the total cost at checkout once you
                  enter your address or contact us our team for more information
                </span>
                <span className="table-cell">-</span>
              </div>
            </div>

            <h3>*Click and Collect</h3>
            <p>
              We are open for same-day Click and Collect in our Brighton shop.
              Our address is:
            </p>
            <p className="address">
              pittleforestandco, 21 Sydney Street, Brighton, BN1 4EN
            </p>
            <p>
              When your order is ready to collect, we'll email you. It'll
              usually be ready on the same day. We're open for collections from
              10am-6pm every day. Call us on 01273 696769 with any questions.
            </p>

            <h3>Special Shipping Enquiries</h3>
            <p>
              For any special shipping enquiries, please contact us on 01273 696
              76 or use the{" "}
              <Link to="/contact" onClick={toTop} className="link">
                contact form
              </Link>
              . We're more than happy to help.
            </p>
          </section>

          <section className="delivery-section">
            <h2>International Shipping and Customs Charges</h2>
            <p>
              You may be charged customs duties when your goods arrive in your
              country and you are fully responsible for paying these charges.
              These can be expensive. We love our customers and don't want to
              lose you, and so we advise that you check what these charges are
              likely to be before placing your order. You can do this by using
              your country's customs calculator which should be available on
              their import website.
            </p>
            <p>
              If you don't pay a customs bill, the parcel will eventually be
              returned to us by the border. In this instance, if the items
              arrive with us in saleable condition, we'll refund the cost of the
              goods in full. Unfortunately, it would be unsustainable for us to
              refund the shipping charges too so please, please, please do your
              research on the customs to avoid unwanted surprises.
            </p>
            <p>
              We use a fully tracked Royal Mail service for international orders
              with delivery times of 2-10 days with prices starting at $12,
              depending on your location and order weight. For exact overseas
              shipping prices and timeframes, please contact us at{" "}
              <strong>round@pittleforestandco.shop</strong>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Delivery;
